import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/github-markdown-css@5.8.1/node_modules/github-markdown-css/github-markdown.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.1.11_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lng]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/independent-mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/independent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/MixpanelAnalytics.tsx");
